import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import { isEmptyVal, isNotEmpty, displayField } from "../../../utils/helpers";

const SingerCell = ({ rowData, ...props }: { rowData: any }) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  const speaker = (
    <Popover title={t("SINGER") + " " + t("NAME")}>
      <p>
        <b>{t("SINGER1")} : </b>
        {displayField(rowData.singer1_name)}
      </p>
      {rowData.singer2_name && (
        <p>
          <b>{t("SINGER2")} : </b>
          {displayField(rowData.singer2_name)}
        </p>
      )}

      {rowData.singer3_name && (
        <p>
          <b>{t("SINGER3")} : </b>
          {displayField(rowData.singer3_name)}
        </p>
      )}

      {rowData.singer4_name && (
        <p>
          <b>{t("SINGER4")} : </b>
          {displayField(rowData.singer4_name)}
        </p>
      )}
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a>{displayField(rowData.singer1_name)}</a>
      </Whisper>
    </Cell>
  );
};

export default SingerCell;
